;(function ($) {
    var pluginName = 'twn-vision';
    var defaults = {
        defaults: {
            font: "md",
            line: "md",
            contrast: "normal"
        },

        fontClass: {
            "md": "",
            "lg": "vision__font--large",
            "xl": "vision__font--extraLarge"
        },

        lineClass: {
            "md": "",
            "lg": "vision__line--large",
            "xl": "vision__line--extraLarge"
        },

        contrastClass: {
            normal: "",
            high: "vision__contrast"
        },

        fontSelector:
            "input:radio[name=fontSize]",
        lineSelector:
            "input:radio[name=lineHeight]",
        contrastSelector:
            "input:radio[name=contrast]"
    };

    var initSelector = '.js-vision';


    function Vision(element, options) {
        this.$vision = $(element);
        this.options = $.extend({}, defaults, options, this.$vision.data());
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }


    Vision.prototype.init = function () {

        //Read from settings
        var isSaved = this.readSettings();

        //set default values;
        this.current = isSaved != null ? isSaved : this.options.defaults;
        this.setValues(this.current);

        //bind events
        this.bindEvents();

        // Set body classes
        this.setClasses(this.current);
    };


    Vision.prototype.bindEvents = function () {
        var _that = this;

        //clear Button
        this.$vision.find("[data-restore=vision]").on("click", this.reset.bind(this));

        //update Button
        this.$vision.find("[data-update=vision]").on("click", this.update.bind(this) );
    };

    /**
     * Get selected values and update states
     */
    Vision.prototype.update = function () {
        this.current = this.getValues();

        // set class names
        this.setClasses(this.current);

        // set cookie
        this.saveSettings();

    };

    /**
     * Reset to default values
     */
    Vision.prototype.reset = function () {
        this.setValues(this.options.defaults);

        // remove classes
        this.clearClasses();

        // clear cookie
        this.clearSettings();
    };

    /**
     * Read currently selected values and return object of values
     */
    Vision.prototype.getValues = function () {
        var current = {};

        current.font = $(this.options.fontSelector + ":checked").val();
        current.line = $(this.options.lineSelector + ":checked").val();
        current.contrast = $(this.options.contrastSelector + ":checked").val();

        return current;
    };


    /**
     * Activate currently selected radio inputs
     * @param values
     */
    Vision.prototype.setValues = function (values) {
        //font
        $(this.options.fontSelector + "[value=" + values.font + "]").click();
        //line
        $(this.options.lineSelector + "[value=" + values.line + "]").click();
        //contrast
        $(this.options.contrastSelector + "[value=" + values.contrast + "]").click();
    };

    /**
     * Save selected values to cookie
     */
    Vision.prototype.saveSettings = function () {
        document.cookie = "visionSettings="+JSON.stringify(this.current)+ "; path=/";
    };

    /**
     * Read settings from cookie
     * @returns {object} - settings object or NULL if not set.
     */
    Vision.prototype.readSettings = function () {
            var _settings = "";
            var name = "visionSettings=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');

            // debugger;
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    _settings =  c.substring(name.length, c.length);
                }
            }

            if(_settings.length == 0){
                _settings = null;
            }

            return JSON.parse(_settings);
    };

    /**
     * Clear cookie
     */
    Vision.prototype.clearSettings = function () {
        document.cookie = "visionSettings=; path=/";
    };

    /**
     * Add classes to body
     * @param classes
     */
    Vision.prototype.setClasses = function (classes) {
        this.clearClasses();

        this.classes = "";

        this.classes +=" "+ this.options.fontClass[classes.font];
        this.classes +=" "+ this.options.lineClass[classes.line];
        this.classes +=" "+ this.options.contrastClass[classes.contrast];

        $("html").addClass(this.classes);

        //call window resize event to adjust elements
        $(window).trigger("resize");
    };

    /**
     * Remove classes from body
     */
    Vision.prototype.clearClasses = function () {
        $("html").removeClass(this.classes);

        //call window resize event to adjust elements
        $(window).trigger("resize");
    };

    /**
     * Destroy the plugin instance
     * @method destroy
     * @returns {void}
     */
    Vision.prototype.destroy = function () {
        this.clearClasses();
        this.clearSettings();
        $(this.$vision[0]).removeData('plugin_' + pluginName);
    };


    /**
     * Create jQuery plugin.
     * @param {Object} options Extended options
     * @returns {Array<Vision>} Array of Maps
     */
    $.fn[pluginName] = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new Vision(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });
    };

    /**
     * @event enhance.twn.vision
     * @param   {Event} event
     */
    $(document).on('enhance.twn.vision', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]();
    });

    /**
     * @event destroy.twn.vision
     * @param   {Event} event
     */
    $(document).on('destroy.twn.vision', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]('destroy');
    });

    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.twn.vision
     */
    $(function () {
        $(document).trigger('enhance.twn.vision');
    });
}(jQuery,window));

